import { useContext } from 'react';
import { calculateGradientCoordinate } from '@/utils/file-kit';
import { type ILayerProps, type ITextLayerProps } from '@/version-types';
import { TextLayerContext } from '../context';

type Props = {
    layer: ILayerProps;
};

export const LinearGradientDef: React.FC<Props> = ({ layer }) => {
    const { defIDSuffix } = useContext(TextLayerContext)!;

    const { id, width, height } = layer;
    const layerData = layer.data as ITextLayerProps;
    const { textGradient } = layerData;

    if (!textGradient || textGradient.colors.length <= 1) return null;

    const coordinates = (() => {
        const { x0: x1, y0: y1, x1: x2, y1: y2 } = calculateGradientCoordinate(width, height, textGradient.angle);
        return {
            x1,
            y1,
            x2,
            y2,
        };
    })();

    const defID = `gradient-${id}-${defIDSuffix}`;

    return (
        <linearGradient id={defID} gradientUnits="userSpaceOnUse" {...coordinates}>
            {textGradient.colors.map((color, idx) => (
                <stop key={`gradient-stop-${idx}`} offset={color.value} stopColor={color.color} />
            ))}
        </linearGradient>
    );
};
